import { render, staticRenderFns } from "./ChartHours.vue?vue&type=template&id=5ece21a4&"
import script from "./ChartHours.vue?vue&type=script&lang=js&"
export * from "./ChartHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports